import React from 'react';

import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import ValidateEmailContainer from './ValidateEmailContainer';
import { CLASS_LOGO_PATH } from '../../config/apiPaths';

const Container = styled.div`
    max-width: 450px;
    margin: 2rem auto 0;
    padding: 4rem;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

const Title = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
    font-size: 24px;
`;

const ImageWrapper = styled.div<{ imageUrl: string }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 175px;
    height: 58px;
    margin: 0 auto 2rem;
    background: transparent url(${(props) => props.imageUrl}) no-repeat center;
    background-size: contain;
`;

const Subtext = styled.div`
    margin-bottom: 1rem;
`;

export interface ValidateEmailProps {}

const ValidateEmailPage: React.FC<ValidateEmailProps> = () => {
    const { t } = useTranslation('validate_email');
    const { isValidToken, isLoading } = useContainer(ValidateEmailContainer);

    if (isLoading) {
        return (
            <Container>
                <ImageWrapper imageUrl={CLASS_LOGO_PATH} />
                <Title>{t('title')}</Title>
                <Subtext>{t('checking')}</Subtext>
            </Container>
        );
    }

    if (isValidToken) {
        return (
            <Container>
                <ImageWrapper imageUrl={CLASS_LOGO_PATH} />
                <Title>{t('title')}</Title>
                <Subtext>{t('success')}</Subtext>
            </Container>
        );
    }

    return (
        <Container>
            <ImageWrapper imageUrl={CLASS_LOGO_PATH} />
            <Title>{t('title')}</Title>
            <Subtext>{t('invalid-token')}</Subtext>
        </Container>
    );
};

export default ValidateEmailPage;
